


import { Emit, Component, Prop, Vue } from 'vue-facing-decorator';
import ToggleButton from './ToggleButton.vue';
import {TCModel} from '@iabtcf/core';
import { Vue3SlideUpDown } from "vue3-slide-up-down";
import ChevronIcon from '../icons/ChevronIcon.vue'


// import {Purpose} from '@iabtcf/core'

// Purpose type not exported (WTF???) so we have to define it here

type Purpose = {
  id: number;
  name: string;
  description: string;
  descriptionLegal?: string;
  illustrations?: string[];
};



@Component({
  components: {
    ToggleButton,
    Vue3SlideUpDown,
    ChevronIcon
  },
})

export default class PurposeItem extends Vue {

    consent = false;
    legitInterestObjection = false;

    expanded = false;
    collapseClass = "collapseButton collapseButtonRotatedUp"

    formattedDescriptions :string[] = [];
    formattedCanNotDescriptions :string[] = [];
    introDescription :string = "Our partners may:";
    vendors?: [];
    illustrations?: string[];
    vendorCount?: number = 0;

    @Prop( { default:{ name:'none', id:0, vendorCount: 0 } }) purpose!: Purpose;
    @Prop( { default: "purpose" }) itemType!: string;

    mounted() : void {
      this.vendors = [];
      this.illustrations = [];

      // @ts-ignore
      let model = window.__cmpTCModel;

      try {
        if ( this.itemType == "purpose")
        {
       //@ts-ignore
       this.vendorCount = Object.keys( window.__GVL.getVendorsWithConsentPurpose( this.purpose.id ) ).length;
        }
          else if( this.itemType == "specialPurpose")
          {
        //@ts-ignore
        this.vendorCount = Object.keys( window.__GVL.getVendorsWithSpecialPurpose( this.purpose.id ) ).length;
          }
          else if( this.itemType == "feature")
          this.vendorCount = 0;
        else if( this.itemType == "specialPurpose")
          this.vendorCount = 0;
    } catch (e) {
      console.log( "Error getting vendor count: " + e );
    }


      this.consent = model.purposeConsents.has( this.purpose.id );
      this.legitInterestObjection = ! model.purposeLegitimateInterests.has( this.purpose.id );

      // console.log( "Purpose " + this.purpose.id + " " +this.consent + " " +this.legitInterestObjection );
      // console.log( model );
      
      this.introDescription = this.purpose?.description;

      // let parts = this.purpose?.description?.split("Vendors cannot:")

      // if (parts && parts.length) {
      //   let s = parts[0].replace("Vendors can:", "")
      //   s = s.replace(/(\r\n|\n|\r)/gm, "")
      //   s = s.replace("N.B. ", " ")

      //   this.formattedDescriptions = s.split("* ").filter( ( e : any ) => Boolean((<String>e).length) );
        
      //   if (this.purpose.id != 1 && this.formattedDescriptions.length ) {
      //     this.introDescription = <string> this.formattedDescriptions.shift(); // remove and return first element
      //   }

      //   if (parts.length > 1) {
      //     let s = parts[1].replace(/(\r\n|\n|\r)/gm, "");
      //     s = s.replace("N.B. ", " ");

      //     this.formattedCanNotDescriptions = s.split("* ").filter( ( e : any ) => Boolean((<String>e).length) );
      //     }
      
      // }
    }

    @Emit('modelChangeEvent')
    changeLegitimateInterest( value: any, srcEvent: any ) {
      //@ts-ignore
    let model :TCModel = window.__cmpTCModel;
      if ( value.value )
        model.purposeLegitimateInterests.unset( this.purpose.id );
      else
        model.purposeLegitimateInterests.set( this.purpose.id );

      this.legitInterestObjection = value.value;
      // console.log( this.legitInterest );

      // this.$emit('modelChangeEvent', true );
    }

    @Emit('modelChangeEvent')
    changeConsent( value: any, srcEvent: any ) {
      //@ts-ignore
    let model :TCModel = window.__cmpTCModel;
      if ( value.value )
        model.purposeConsents.set( this.purpose.id );
      else
        model.purposeConsents.unset( this.purpose.id );
      
      this.consent = value.value;

      // console.log( this.consent );

      // this.$emit('modelChangeEvent', true );
    }

    expandCollapseClick() {
      if ( ! this.expanded )
        this.collapseClass = 'collapseButton collapseButtonRotatedDown';
      else
        this.collapseClass = 'collapseButton collapseButtonRotatedUp';

      this.expanded = ! this.expanded;
    }

    viewIllustrations() {
      this.vendors = [];
     this.illustrations = this.purpose.illustrations;
    }

    viewVendorsClick() {
      this.illustrations = [];

        // @ts-ignore

        let model : TCModel = window.__cmpTCModel;

        if ( model && model.gvl) {
          let vendorsWithPurpose = {};
          
          try 
          {
            if ( this.itemType == "purpose")
              vendorsWithPurpose = model.gvl.getVendorsWithConsentPurpose( this.purpose.id );
            else if( this.itemType == "specialPurpose")
              vendorsWithPurpose = model.gvl.getVendorsWithSpecialPurpose( this.purpose.id );
          } catch (e) {
            console.log( "Error getting vendors with purpose: " + e );
          }


          let keys = Object.keys( vendorsWithPurpose );

          let vendorsText = "";
         for ( let i =0; i < keys.length; i++ ) {
          // @ts-ignore
            let thisVendor = vendorsWithPurpose[ keys[i] ];
            if (i > 0)
              vendorsText += ", ";
            vendorsText += "(" + (i+1).toString() + ") " + thisVendor.name;
        }

        // @ts-ignore
        this.vendors = [ vendorsText ];


        }
      }


}

